<template>
    <span :class="{'vc-base-play--sm': small}" @click="$emit('click', $event)" class="vc-base-play">
        <svg id="play-button" version="1.1" viewBox="0 0 46.9 46.9" x="0px"
             xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
        <path :fill="backgroundColor" d="M23.5,46.9C10.5,46.9,0,36.4,0,23.5
	C0,10.5,36.4,46.9,23.5,46.9z" id="Path_523" style="opacity:0.525;"/>
        <path :fill="backgroundColor" d="M23.5,0c13,0,23.5,10.5,23.5,23.5
	C46.9,36.4,10.5,0,23.5,0z" id="Path_524" style="opacity:0.525;"/>
        <path :fill="backgroundColor" d="M23.5,3.9C34.3,3.9,43,12.7,43,23.5S34.3,43,23.5,43S3.9,34.3,3.9,23.5
	S12.7,3.9,23.5,3.9C23.5,3.9,23.5,3.9,23.5,3.9z" id="Path_525"/>
        <template v-if="!paused">
            <path :fill="iconColor" d="M16.8,23.5V16c0-1,1.1-1.7,2-1.2l6.5,3.7l6.5,3.7c0.9,0.5,0.9,1.8,0,2.3l-6.5,3.7l-6.5,3.7
	c-0.9,0.5-2-0.1-2-1.2V23.5z"/>
        </template>
        <template v-else>
            <g>
               	<path :fill="iconColor" d="M21.1,31.3h-3.1c-0.5,0-0.9-0.4-0.9-0.9V16.5c0-0.5,0.4-0.9,0.9-0.9h3.1c0.5,0,0.9,0.4,0.9,0.9v13.9
		C22,30.9,21.6,31.3,21.1,31.3z"/>
                <path :fill="iconColor" d="M29,31.3h-3.1c-0.5,0-0.9-0.4-0.9-0.9V16.5c0-0.5,0.4-0.9,0.9-0.9H29c0.5,0,0.9,0.4,0.9,0.9v13.9
		C29.9,30.9,29.5,31.3,29,31.3z"/>
            </g>
        </template>
    </svg>
    </span>
</template>

<script>
    export default {
        name: "base-play-svg",
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
            iconColor: {
                type: String,
                required: true,
            },
            small: {
                type: Boolean,
                default: false,
            },
            paused: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .vc-base-play {
        display: inline-block;
        user-select: none;
        width: 46px;
        height: 46px;
        cursor: pointer;

        &--sm {
            width: 30px;
            height: 30px;
        }
    }
</style>